var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},[_c('Preloader',{staticClass:"wrapper__preloader",class:{
        'show': _vm.preloader_status
      }}),_vm._l((_vm.domains),function(site,id){return _c('ListElement',{key:id,attrs:{"site":site}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }